/**
 * @generated SignedSource<<c20cd5e72951f188928d2a9701ff7bba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type afterReciveInviteChatQuery$variables = {
  linkparameter: string;
};
export type afterReciveInviteChatQuery$data = {
  readonly insurance_request_log_connection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly aiconsultdetailid: number | null | undefined;
        readonly caredetailid: number | null | undefined;
        readonly created_at: any | null | undefined;
        readonly id: string;
        readonly insuranceid: string;
        readonly recipientid: string | null | undefined;
        readonly request_ai_consult_details: {
          readonly created_at: any;
          readonly id: string;
          readonly linkparameter: string;
          readonly startchatdate: any | null | undefined;
        } | null | undefined;
        readonly requeststatus: number;
        readonly requesttype: number;
      };
    }>;
  };
};
export type afterReciveInviteChatQuery = {
  response: afterReciveInviteChatQuery$data;
  variables: afterReciveInviteChatQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "linkparameter"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created_at",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "_eq",
                    "variableName": "linkparameter"
                  }
                ],
                "kind": "ObjectValue",
                "name": "linkparameter"
              }
            ],
            "kind": "ObjectValue",
            "name": "request_ai_consult_details"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "insurance_request_logConnection",
    "kind": "LinkedField",
    "name": "insurance_request_log_connection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "insurance_request_logEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "insurance_request_log",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "request_ai_consult_detail",
                "kind": "LinkedField",
                "name": "request_ai_consult_details",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "linkparameter",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startchatdate",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requeststatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requesttype",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recipientid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "insuranceid",
                "storageKey": null
              },
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "caredetailid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "aiconsultdetailid",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "afterReciveInviteChatQuery",
    "selections": (v3/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "afterReciveInviteChatQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "492633f3a28d29528cde2dc746763db4",
    "id": null,
    "metadata": {},
    "name": "afterReciveInviteChatQuery",
    "operationKind": "query",
    "text": "query afterReciveInviteChatQuery(\n  $linkparameter: String!\n) {\n  insurance_request_log_connection(where: {request_ai_consult_details: {linkparameter: {_eq: $linkparameter}}}) {\n    edges {\n      node {\n        request_ai_consult_details {\n          id\n          linkparameter\n          startchatdate\n          created_at\n        }\n        requeststatus\n        requesttype\n        recipientid\n        insuranceid\n        id\n        created_at\n        caredetailid\n        aiconsultdetailid\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "79a9a565fc71e4aa64b90528b56464a1";

export default node;
